import { EventSummaryDocument } from "./EventSummaryDocument";
import TestPdf from "../utils/dummy.pdf";

export default {
  title: "SecurityPortal/Events/EventSummaryDocument",
  component: EventSummaryDocument,
  decorators: [
    (Story) => (
      <div
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            overflow: "scroll",
            width: "50vw",
          }}
        >
          <Story />
        </div>
        <a style={{ color: "red", width: "fit-content" }} id="event-summary">
          Download loading...
        </a>
      </div>
    ),
  ],
};

const Template = (args) => <EventSummaryDocument {...args} />;

const sampleKeyContact = {
  position: "Tester",
  name: "Last, First",
  number: "000-000-0000",
  email: "name@email.com",
};

const sampleKeyLocation = {
  name: "Tester",
  address1: "Address Line 1",
  address2: "Address Line 2",
  phoneNumber: "(000) 000-0000",
};

const sampleStaff = {
  pinned: false,
  name: "Last, First",
  phoneNumber: "000-000-0000",
  email: "name@email.com",
  CCW: false,
};

const sampleIncidents = [
  {
    number: "2021-12-00001234",
    status: "Action Required",
    type: "Harassment",
    severity: "Level 1",
    iboNum: "1234",
    caseOwner: "Jack",
    dateCreated: "12-04-2021",
  },
  {
    number: "2021-12-00001235",
    status: "Read",
    type: "Hate Speech / Racism",
    severity: "Level 2",
    iboNum: "5678",
    caseOwner: "Jill",
    dateCreated: "12-03-2021",
  },
  {
    number: "2021-12-00001234",
    status: "Reviewed",
    type: "Violence",
    severity: "Level 3",
    iboNum: "9876",
    caseOwner: "Dale",
    dateCreated: "12-02-2021",
  },
  {
    number: "2021-12-00001235",
    status: "New",
    type: "Lookup Abuse",
    severity: "Level 4",
    iboNum: "5432",
    caseOwner: "Diane",
    dateCreated: "12-01-2021",
  },
  {
    number: "2021-12-00001235",
    status: "New",
    type: "Other -",
    severity: "Level 4",
    iboNum: "5432",
    caseOwner: "Diane",
    dateCreated: "11-01-1999",
  },
];

export const Default = Template.bind({});
Default.args = {
  centerInfo: {
    address1: "123 Street Address",
    address2: "City, State 12345",
    phoneNumber: "000-000-0000",
    email: "janesmith@gmail.com",
    emergencyContact: "Jane Smith",
  },
  event: {
    name: "Spring Leadership 2022",
    center: "Las Vegas Event Center",
    city: "Las Vegas",
    state: "Nevada",
    date: "01-01-2022",
    complaints: 27,
  },
  emergencyDocs: [{ name: "Emergency Document", src: TestPdf }],
  documents: [{ name: "Document", src: TestPdf }],
  keyContacts: [
    { ...sampleKeyContact, position: "Event Planner" },
    { ...sampleKeyContact, position: "Head of Security" },
    { ...sampleKeyContact, position: "Productions Lead" },
    { ...sampleKeyContact, position: "PR Contact" },
    { ...sampleKeyContact, position: "Event Host" },
    { ...sampleKeyContact, position: "Event Representative" },
    { ...sampleKeyContact, position: "PR Representative" },
    { ...sampleKeyContact, position: "Event Attendee" },
    sampleKeyContact,
    sampleKeyContact,
    sampleKeyContact,
    sampleKeyContact,
    sampleKeyContact,
    sampleKeyContact,
    sampleKeyContact,
  ],
  keyLocations: [
    {
      ...sampleKeyLocation,
      name: "Hospital",
    },
    {
      ...sampleKeyLocation,
      name: "Police Station",
    },
    {
      ...sampleKeyLocation,
      name: "FBI Office",
    },
  ],
  specialCircumstances: "Circumstances...",
  securityTeam: [
    { ...sampleStaff, CCW: true },
    sampleStaff,
    sampleStaff,
    sampleStaff,
    { ...sampleStaff, pinned: true },
    sampleStaff,
    sampleStaff,
  ],
  eventStaff: [
    sampleStaff,
    sampleStaff,
    { ...sampleStaff, pinned: true },
    sampleStaff,
    { ...sampleStaff, pinned: true },
    sampleStaff,
    { ...sampleStaff, CCW: true },
  ],
  nearbyIncidents: [
    ...sampleIncidents,
    ...sampleIncidents,
    ...sampleIncidents,
    ...sampleIncidents,
    ...sampleIncidents,
  ],
  onLoad: (data) => {
    const a = document.getElementById("event-summary");
    a.innerText = "Download Me!";
    a.href = data.url;
    a.download = "EventSummaryDocument.pdf";
  },
};
